export default "__VITE_ASSET__BtQbKTUW__"